import React from "react";
import HyroTextField from "../text-field/HyroTextField";
import CodeExpressionIcon from "src/icons/field-actions/CodeExpressionIcon";
import { toExpressionDefault } from "src/components/collections/expression-dialog-v2/ExpressionDialogV2.utils";
import { ClickableFieldWrapper } from "./HyroExpressionField.styles";
import { EXPRESSION_FIELD_STRINGS, EXPRESSION_FIELD_TEST_IDS } from "./HyroExpressionField.consts";

const HyroExpressionField = ({ value, onExpressionClick, placeholder, readOnly: _readOnly, InputProps, ...textFieldProps }) => {
  const handleKeyDown = (event) => {
    if (onExpressionClick && (event.key === "Enter" || event.key === " ")) {
      event.preventDefault();
      onExpressionClick();
    }
  };

  return (
    <ClickableFieldWrapper
      clickable={!!onExpressionClick}
      onClick={onExpressionClick}
      data-testid={EXPRESSION_FIELD_TEST_IDS.WRAPPER}
    >
      <HyroTextField
        {...textFieldProps}
        value={toExpressionDefault(value)}
        placeholder={placeholder || EXPRESSION_FIELD_STRINGS.PLACEHOLDER}
        showCopyButton={false}
        isFieldReadOnlyFromSpec
        usesExpression
        onKeyDown={handleKeyDown}
        InputProps={{
          ...InputProps,
          readOnly: true,
          "aria-haspopup": "dialog",
          endAdornment: (
            <span data-testid={EXPRESSION_FIELD_TEST_IDS.ICON} style={{ display: "inline-flex" }}>
              <CodeExpressionIcon size={18} style={{ flexShrink: 0, marginLeft: "12px" }} />
            </span>
          )
        }}
      />
    </ClickableFieldWrapper>
  );
};

export default HyroExpressionField;
